// src/hooks/useConfig.js — loads and manages admin-curated config lists
import { useState, useEffect, useCallback } from 'react'
import { getConfig, setConfigKey } from '../db/index.js'

export function useConfig() {
  const [config,  setConfig]  = useState({ agent_roles: [], districts: [], candidate_sources: [], languages: [], role_commissions: {} })
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    getConfig().then(c => { setConfig(c); setLoading(false) }).catch(() => setLoading(false))
  }, [])

  const updateKey = useCallback(async (key, values) => {
    await setConfigKey(key, values)
    setConfig(prev => ({ ...prev, [key]: values }))
  }, [])

  return { config, loading, updateKey }
}
